

const leadList = (search, access_token) => {
    console.log('leads list')
    return new Promise((resolve, reject) => {
        axios.get('/api/lead/list', {
            params: { s: search ? search : null },
            headers: { Authorization: 'Bearer ' + access_token }
        }).then(res => {
            resolve(res.data)
        }, res => {
            reject(res.response)
        })
    })
}

const leadSummary = (access_token) => {
    console.log('leads summary')
    return new Promise((resolve, reject) => {
        axios.get('/api/lead/summary', {
            headers: { Authorization: 'Bearer ' + access_token }
        }).then(res => {
            resolve(res.data)
        }, res => {
            reject(res.response)
        })
    })
}

const createLead = (data, access_token) => {
    console.log('create lead')
    return new Promise((resolve, reject) => {
        axios.post('/api/lead', data, {
            headers: { Authorization: 'Bearer ' + access_token }
        }).then(res => {
            resolve(res.data)
        }, res => {
            reject(res.response)
        })
    })
}

const updateLead = (data, access_token) => {
    console.log('update lead')
    return new Promise((resolve, reject) => {
        axios.post('/api/lead/' + data.id, data, {
            headers: { Authorization: 'Bearer ' + access_token }
        }).then(res => {
            resolve(res.data)
        }, res => {
            reject(res.response)
        })
    })
}

const deleteLead = (id, access_token) => {
    console.log('delete lead')
    return new Promise((resolve, reject) => {
        axios.delete('/api/lead/' +id, {
            headers: { Authorization: 'Bearer ' + access_token }
        }).then(res => {
            resolve(res.data)
        }, res => {
            reject(res.response)
        })
    })
}

const viewLead = (id, access_token) => {
    console.log('view lead')
    return new Promise((resolve, reject) => {
        axios.get('/api/lead/' + id, {
            headers: { Authorization: 'Bearer ' + access_token }
        }).then(res => {
            resolve(res.data)
        }, res => {
            reject(res.response)
        })
    })
}

const stepLead = (id, data, access_token) => {
    console.log('step lead')
    return new Promise((resolve, reject) => {
        axios.post('/api/lead/step/' + id, data, {
            headers: { Authorization: 'Bearer ' + access_token }
        }).then(res => {
            resolve(res.data)
        }, res => {
            reject(res.response)
        })
    })
}

export {
    leadList,
    leadSummary,    
    createLead,
    updateLead,
    viewLead,
    deleteLead,
    stepLead
}